export default "__VITE_ASSET__CtIFDkwe__"